/*
id is a designated id for the link
text what it will display
url is the destination of the link
*/
const data = [
  {
    id: 1,
    text: "Home",
    url: "/",
  },
  {
    id: 2,
    text: "AboutMe",
    url: "/about/",
  },
  {
    id: 3,
    text: "Projects",
    url: "/projects/",
  },
  {
    id: 5,
    text: "Connect",
    url: "/contact/",
  },
]

export default data
